import usePersonalizedThemeByCompany from "src/hooks/usePersonalizedThemeByCompany"

type Props = {
  width: string
}

export default function CloseIcon({ width} : Props) {
  const {styledTheme} = usePersonalizedThemeByCompany()

  return (
<svg width={width} height={width} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.0792 8.17678L15.6464 13.744L13.744 15.6464L8.17678 10.0792L8 9.90245L7.82322 10.0792L2.256 15.6464L0.353554 13.744L5.92078 8.17678L6.09755 8L5.92078 7.82322L0.353553 2.256L2.256 0.353553L7.82322 5.92078L8 6.09755L8.17678 5.92078L13.744 0.353554L15.6464 2.256L10.0792 7.82322L9.90245 8L10.0792 8.17678Z" fill={styledTheme.colors.primary} stroke="white" stroke-width="0.5"/>
</svg>)
}
